"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("../Theme/constant");

var _text = _interopRequireDefault(require("../Text/text.proptypes"));

var _spinner = _interopRequireDefault(require("../Spinner/spinner.proptypes")); // import { DEFAULT_THEME, ARR_COLORS, ARR_SPACING_TYPES } from '@components/Theme/constant';


var _default = {
  PropTypes: {
    backgroundColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    primaryText: _propTypes.string,
    secondaryText: _propTypes.string,
    primaryTextConfig: (0, _propTypes.shape)(_text.default.PropTypes),
    secondaryTextConfig: (0, _propTypes.shape)(_text.default.PropTypes),
    spinnerConfig: (0, _propTypes.shape)(_spinner.default.PropTypes),
    show: _propTypes.bool,
    customProperties: _propTypes.object,
    accessible: _propTypes.bool,
    theme: _propTypes.string
  },
  DefaultProps: {
    show: false,
    accessible: true,
    theme: _constant.DEFAULT_THEME,
    backgroundColor: 'charcoalGrey',
    primaryTextConfig: {
      display: 'block',
      color: 'default',
      type: 'titleSmall',
      textAlign: 'center'
    },
    secondaryTextConfig: {
      display: 'block',
      color: 'default',
      type: 'titleSmall',
      textAlign: 'center'
    },
    spinnerConfig: {
      height: '48',
      width: '48',
      color: 'default',
      animationDuration: '1s',
      strokeWidth: '2'
    }
  }
};
exports.default = _default;